
module.exports = {
	REQUEST_SURVEYS: "REQUEST_SURVEYS",
	RECEIVE_SURVEYS: "RECEIVE_SURVEYS",
	REQUEST_SURVEYS_ERROR: "REQUEST_SURVEYS_ERROR",
    CLEAR_SURVEYS_ERROR: "CLEAR_SURVEYS_ERROR",
	START_SURVEY: "START_SURVEY",
	END_SURVEY: "END_SURVEY",
	UPDATE_SEQUENCE_INDEX: "UPDATE_SEQUENCE_INDEX",
	UPDATE_SURVEY_INDEX: "UPDATE_SURVEY_INDEX",
	TOGGLE_SEQUENCE: "TOGGLE_SEQUENCE",
	CHANGE_SEQUENCE: "CHANGE_SEQUENCE",
	SET_RESPONSE: "SET_RESPONSE",
	UPDATE_SURVEY_LIST: "UPDATE_SURVEY_LIST",
	SEED_SURVEY_LIST: "SEED_SURVEY_LIST",
	CLEAR_PREVIOUS_STATE: "CLEAR_PREVIOUS_STATE",
    UPDATE_SURVEY_PROGRESS: "UPDATE_SURVEY_PROGRESS"
};



// WEBPACK FOOTER //
// ./src/common/modules/survey/constants.js